export type Gradient = [string, string]

const CALMING_GRADIENTS: Gradient[] = [
  ["#fff4d6", "#f5c4a0"],
  ["#e8f4e8", "#c5e4d4"],
  ["#e8eef8", "#c8d4f0"],
  ["#f8efe8", "#e8c8c0"],
  ["#f0f4e0", "#d4e0b8"],
  ["#f4e8f4", "#d8c8e8"],
  ["#e0f4f4", "#b8dce0"],
  ["#fff0e0", "#f0d0a8"],
  ["#e8f0e4", "#c0d8c8"],
  ["#f8f0d8", "#e8d0b0"],
  ["#ece8f8", "#d0c8e8"],
  ["#f4e8e0", "#e0c8b8"],
]

const hashString = (value: string) => {
  let hash = 0
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

const stripHtml = (html: string) => html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()

export const gradientForLetter = (title: string, period: string, content: string): Gradient => {
  const seed = `${title} ${period}`.trim()
  const fingerprint = seed.length > 0 && seed !== "Wochenbrief" ? seed : stripHtml(content).slice(0, 80)
  return CALMING_GRADIENTS[hashString(fingerprint || title) % CALMING_GRADIENTS.length]
}
